/**
 * CetusEd Community Portal — Card Component
 *
 * COMPLIANCE: Cards surface grouped information (document lists, message
 *   threads). Each card should have a heading that describes its content
 *   for screen reader navigation (WCAG 2.1 AA SC 1.3.1).
 */

import React from 'react';

export interface CardProps {
  children: React.ReactNode;
  title?: string;
  className?: string;
  onClick?: () => void;
}

export const Card: React.FC<CardProps> = ({ children, title, className = '', onClick }) => {
  const classes = ['community-card', onClick ? 'community-card--clickable' : '', className]
    .filter(Boolean)
    .join(' ');

  return (
    <div
      className={classes}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onClick={onClick}
      onKeyDown={onClick ? (e) => { if (e.key === 'Enter' || e.key === ' ') onClick(); } : undefined}
    >
      {title && <h3 className="card-title">{title}</h3>}
      {children}
    </div>
  );
};
